import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-tags-filter',
  templateUrl: './tags-filter.component.html',
  styleUrls: ['./tags-filter.component.scss']
})
export class TagsFilterComponent implements IFilterAngularComp {

  params!: IFilterParams;
  mode: 'include' | 'exclude' = 'include';
  searchText = '';
  allTags: string[] = [];
  selectedTags: Set<string> = new Set();

  get filteredTags(): string[] {
    if (!this.searchText) {
      return this.allTags.slice(0, 200);
    }
    const search = this.searchText.toLowerCase();
    return this.allTags.filter(tag => tag.toLowerCase().includes(search)).slice(0, 200);
  }

  agInit(params: IFilterParams): void {
    this.params = params;
    const fp = params as any;
    if (fp.tags) {
      const tags = fp.tags();
      if (Array.isArray(tags)) {
        this.allTags = tags.map((t: any) => t.name).sort((a: string, b: string) => a.localeCompare(b));
      }
    }
  }

  isFilterActive(): boolean {
    return this.selectedTags.size > 0;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return true;
  }

  getModel(): any {
    if (this.selectedTags.size === 0) {
      return null;
    }
    return {
      filterType: 'set',
      values: Array.from(this.selectedTags),
      mode: this.mode
    };
  }

  setModel(model: any): void {
    if (model) {
      this.selectedTags = new Set(model.values || []);
      this.mode = model.mode || 'include';
    } else {
      this.selectedTags.clear();
      this.mode = 'include';
    }
  }

  setMode(mode: 'include' | 'exclude'): void {
    if (this.mode !== mode) {
      this.mode = mode;
      if (this.selectedTags.size > 0) {
        this.params.filterChangedCallback();
      }
    }
  }

  toggleTag(tag: string): void {
    if (this.selectedTags.has(tag)) {
      this.selectedTags.delete(tag);
    } else {
      this.selectedTags.add(tag);
    }
    this.params.filterChangedCallback();
  }

  isSelected(tag: string): boolean {
    return this.selectedTags.has(tag);
  }

  selectAll(): void {
    this.filteredTags.forEach(tag => this.selectedTags.add(tag));
    this.params.filterChangedCallback();
  }

  deselectAll(): void {
    if (this.searchText) {
      this.filteredTags.forEach(tag => this.selectedTags.delete(tag));
    } else {
      this.selectedTags.clear();
    }
    this.params.filterChangedCallback();
  }
}
